import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription, throwError } from 'rxjs';
import { ApiDocumentationService } from '../../shared/services/api-documentation.service';
import { StepperServiceService } from '../../shared/services/stepper-service.service';
import { AddItemBackofficeDialogComponent } from '../add-item-backoffice-dialog/add-item-backoffice-dialog.component';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { AuthService } from '../../shared/services/auth.service';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { Permission } from '../../shared/security/permission';

@Component({
  standalone: false,
  selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

    Permission = Permission
    variables: any;
    arr1: any = [];

    isLoading: boolean = true;
    errorDetected: boolean = false;
    errorText: any;
    errorMessages: any;

    // Form and sub form. It is needed to link parent form with this component form.
    form: any;
    @Input() canEditCatalog: boolean = false;
    subForm: any;
    private sub: Subscription | undefined = undefined;
    tecnologia: any; //Which technology is being created or edited.

    @Input() listItem: any = []; //List of documentations choosen by the user.
    alreadyInCatalog: any[] = []; //List of users already in catalog
    allUsers: any[] = []; //List of all users in the system.

    constructor(
        private _formBuilder: FormBuilder,
        private ctrlContainer: FormGroupDirective,
        public authService: AuthService,
        private stepperService: StepperServiceService,
        public dialog: MatDialog,
        private documentationService: ApiDocumentationService,
        private route: ActivatedRoute,
        private infoBar: InfoBarWithStatusService,
        private languageService: LanguageService,
        private _snackBar: MatSnackBar,
        private usersManagementService: UsersManagementService,
        private tecnologiasService: TecnologiasService,
    ) { }

    ngOnInit(): void {
        this.languageService.translations$.subscribe((vars: any) => {
            this.variables = vars;
        });

        this.sub = this.stepperService.dataChange.subscribe((data: any) => {
            this.tecnologia = data;
        });

        //Link sub form and form
        this.subForm = this._formBuilder.group({
            users: [''],
        });

        this.form = this.ctrlContainer.form;
        this.form.addControl("formGroup3", this.subForm);
        this.subForm.status = "INVALID";
        this.form.status = "INVALID";

        this.usersManagementService.getAllUsers().pipe(
          retryWhen(errors =>
            errors.pipe(
              scan((retryCount, error) => {
                if (retryCount >= 3) {
                  throw error;
                }
                return retryCount + 1;
              }, 0),
              delay(2500)
            )
          ),
          catchError(err => {
            console.error('Error:', err);

            this.errorDetected = true;
            const message = this.errorMessages[err.error.message]
            this.errorText = message ? message : this.variables.detectedError;

            return throwError(() => err);
          })
        ).subscribe({
          next: (data) => {
              data.forEach((user: any) => {
                    this.allUsers.push({ 'id': user.id, 'name': user.name + " " + user.lastName, 'email': user.email });
                })
          },
          complete: () => this.isLoading = false
        });

    }


    ngOnChanges(changes: SimpleChanges) {

        this.alreadyInCatalog = changes.listItem.currentValue
    }



    openDialogProject() {
        var arrAll;
        this.arr1 = [];
        arrAll = this.listItem;

        if (arrAll && arrAll.length != 0) {
            for (var i = 0; i < arrAll.length; i++) {
                this.arr1.push(arrAll[i].dasID);
            }
        }

        // Prepare data to be passed to dialog component
        const data = {
            title: this.variables.addUsers,
            isActionType: false,
            isUsers: true,
            listInDB: this.alreadyInCatalog,
            users: this.listItem,
            allUsers: this.allUsers
        };


        let dialogRef = this.dialog.open(UserDialogComponent, {
            data: data
        });


        //Add item to array
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.arr1 && this.arr1.includes(result.data.dasID)) {
                    this._snackBar.open(this.variables.snackBarErrorAddUser);
                }
                else {
                   let user = {
                        "name": result.data.userName,
                        "email": result.data.dasID
                    }
                    if (!this.listItem) {
                        this.listItem = [];
                    }
                    this.listItem.push(user);
                }
            }
        });
    }

    openDialogEditProject(item: any) {
        var arrAll;
        this.arr1 = [];
        arrAll = this.listItem;

        for (var i = 0; i < arrAll.length; i++) {
            this.arr1.push(arrAll[i].email);
        }

        const index = this.arr1.indexOf(item.dasID);
        if (index !== -1) {
            this.arr1.splice(index, 1);
        } else {
        }

        //Prepare data to be passed to dialog component
        item.title = this.variables.editUser + ' ' + item.name;

        const data = {
            title: item.title,
            type: 'edit',
            isEdit: true,
            item: item,
            listInDB: this.alreadyInCatalog,
            isActionType: false,
            isUsers: true,
            users: this.listItem,
            allUsers: this.allUsers
        }

        let dialogRef = this.dialog.open(UserDialogComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            // Get result and update item on the arr
            if (result?.data) {
                this.listItem.forEach((v: any) => {

                    if (v.email === item.email) {
                        v.name = result.data.userName;
                        v.email = result.data.dasID;
                        this.alreadyInCatalog.push(v)
                    }
                });
                this.infoBar.showSnackbar(this.variables.successfullyEditedUser, ['successful-snackbar'], 4000);

            }
        })
    }

    openDialogRemove(email: string) {
        let dialogRef = this.dialog.open(RemoveDialogComponent);

        dialogRef.afterClosed().subscribe(result => {
            // Remove item
            if (result === 'true') {
                this.listItem = this.listItem.filter((item: any) => {
                    return item.email != email;
                });
                this.alreadyInCatalog = this.alreadyInCatalog.filter((item: any) => {
                    return item.email != email;
                });

                //this.infoBar.showSnackbar(this.variables.successfullyRemovedUser, ['successful-snackbar'], 4000);

            }
        });
    }

}
